import React from 'react';

export const PIP_LAYOUTS = {
  A: [{ x: 128, y: 188, scale: 2.35 }],
  2: [
    { x: 128, y: 112 },
    { x: 128, y: 268, flip: true },
  ],
  3: [
    { x: 128, y: 102 },
    { x: 128, y: 188 },
    { x: 128, y: 274, flip: true },
  ],
  4: [
    { x: 86, y: 112 },
    { x: 170, y: 112 },
    { x: 86, y: 268, flip: true },
    { x: 170, y: 268, flip: true },
  ],
  5: [
    { x: 86, y: 112 },
    { x: 170, y: 112 },
    { x: 128, y: 190 },
    { x: 86, y: 268, flip: true },
    { x: 170, y: 268, flip: true },
  ],
  6: [
    { x: 86, y: 104 },
    { x: 86, y: 188 },
    { x: 86, y: 272, flip: true },
    { x: 170, y: 104 },
    { x: 170, y: 188 },
    { x: 170, y: 272, flip: true },
  ],
  7: [
    { x: 128, y: 94 },
    { x: 86, y: 134 },
    { x: 170, y: 134 },
    { x: 128, y: 188 },
    { x: 86, y: 242, flip: true },
    { x: 170, y: 242, flip: true },
    { x: 128, y: 282, flip: true },
  ],
  8: [
    { x: 86, y: 98 },
    { x: 170, y: 98 },
    { x: 86, y: 148 },
    { x: 170, y: 148 },
    { x: 86, y: 228, flip: true },
    { x: 170, y: 228, flip: true },
    { x: 86, y: 278, flip: true },
    { x: 170, y: 278, flip: true },
  ],
  9: [
    { x: 86, y: 100 },
    { x: 128, y: 100 },
    { x: 170, y: 100 },
    { x: 86, y: 188 },
    { x: 128, y: 188 },
    { x: 170, y: 188 },
    { x: 86, y: 276, flip: true },
    { x: 128, y: 276, flip: true },
    { x: 170, y: 276, flip: true },
  ],
  10: [
    { x: 86, y: 94 },
    { x: 170, y: 94 },
    { x: 86, y: 134 },
    { x: 170, y: 134 },
    { x: 86, y: 188 },
    { x: 170, y: 188 },
    { x: 86, y: 232, flip: true },
    { x: 170, y: 232, flip: true },
    { x: 86, y: 272, flip: true },
    { x: 170, y: 272, flip: true },
  ],
};

export function CardPips({ rank, suitChar, color }) {
  const layout = PIP_LAYOUTS[rank];
  if (!layout) return null;

  return (
    <g id="cardpips">
      {layout.map((pip, idx) => {
        const scale = pip.scale || 1;
        const rotate = pip.flip ? 180 : 0;
        return (
          <g
            key={idx}
            transform={`translate(${pip.x},${pip.y}) scale(${scale}) rotate(${rotate})`}
          >
            <text
              x="0"
              y="0"
              textAnchor="middle"
              dominantBaseline="central"
              fontSize="46"
              fill={color}
              stroke={color}
            >
              {suitChar}
            </text>
          </g>
        );
      })}
    </g>
  );
}